'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { trackUTMAttribution, debugAttributionStatus } from '../lib/utmTracking';

/**
 * UTM Tracker Component
 * 
 * Tracks UTM parameters and manages attribution cookies automatically.
 * This component renders nothing visible - it only manages tracking logic.
 */
export default function UTMTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    try {
      // Track UTM attribution on every page load or navigation
      const result = trackUTMAttribution();
      if (process.env.NODE_ENV === 'development') {
        if (result.firstTouchSet || result.lastTouchSet) {
          console.log('[UTM Tracker] Attribution updated:', {
            firstTouch: result.firstTouchSet ? 'Set' : 'Unchanged',
            lastTouch: result.lastTouchSet ? 'Updated' : 'No params',
            params: result.params
          });
        }

        // debugAttributionStatus();
      }
    } catch (error) {
      // Fail silently 
      // console.error('[UTM Tracker] Error tracking attribution:', error);
    }
  }, [pathname, searchParams]);
  return null;
}